import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const close: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M9.922-2.203a.74.74 0 0 1 .219.531q-.001.316-.22.531L8.86-.078a.74.74 0 0 1-.53.219.72.72 0 0 1-.532-.22L5.5-2.374 3.203-.078a.74.74 0 0 1-.531.219.72.72 0 0 1-.531-.22L1.078-1.14a.7.7 0 0 1-.219-.53.72.72 0 0 1 .22-.532L3.374-4.5 1.078-6.797a.7.7 0 0 1-.219-.531.72.72 0 0 1 .22-.531L2.14-8.922a.72.72 0 0 1 .53-.219q.311.001.532.22L5.5-6.626l2.297-2.297a.72.72 0 0 1 .531-.219q.31.001.531.22L9.922-7.86a.74.74 0 0 1 .219.53q-.001.317-.22.532L7.626-4.5zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.86 9.14)"
    />
  ),
  svgProps: {
    height: "9.281",
    width: "9.281",
  }
};